import { render, staticRenderFns } from "./PageBadgeCollection.vue?vue&type=template&id=609a526a&scoped=true&"
import script from "./PageBadgeCollection.vue?vue&type=script&lang=js&"
export * from "./PageBadgeCollection.vue?vue&type=script&lang=js&"
import style0 from "./PageBadgeCollection.vue?vue&type=style&index=0&id=609a526a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a526a",
  null
  
)

export default component.exports